import React from 'react';
import { map, padStart, range } from 'lodash';
import Select from 'react-select';
import {
  baseSelectStyles,
  getCurrentSelectedOption,
  SelectInput,
  SelectOption,
} from './rselect/ReactSelectUtils';
import { getLocalTimeZoneLabel } from '../../lib/DateUtils';

function generateNumOptions(start, end, step) {
  return map(
    map(range(start, end, step), (num) => padStart(num, 2, '0')),
    (num) => ({
      label: num,
      value: num,
    }),
  );
}

const DAY_OF_WEEK_OPTIONS = [
  { label: 'Sunday', value: '0' },
  { label: 'Monday', value: '1' },
  { label: 'Tuesday', value: '2' },
  { label: 'Wednesday', value: '3' },
  { label: 'Thursday', value: '4' },
  { label: 'Friday', value: '5' },
  { label: 'Saturday', value: '6' },
];
const DAY_OF_MONTH_OPTIONS = [
  { label: '1st', value: '1' },
  { label: '2nd', value: '2' },
  { label: '3rd', value: '3' },
  { label: '4th', value: '4' },
  { label: '5th', value: '5' },
  { label: '6th', value: '6' },
  { label: '7th', value: '7' },
  { label: '8th', value: '8' },
  { label: '9th', value: '9' },
  { label: '10th', value: '10' },
  { label: '11th', value: '11' },
  { label: '12th', value: '12' },
  { label: '13th', value: '13' },
  { label: '14th', value: '14' },
  { label: '15th', value: '15' },
  { label: '16th', value: '16' },
  { label: '17th', value: '17' },
  { label: '18th', value: '18' },
  { label: '19th', value: '19' },
  { label: '20th', value: '20' },
  { label: '21st', value: '21' },
  { label: '22nd', value: '22' },
  { label: '23rd', value: '23' },
  { label: '24th', value: '24' },
  { label: '25th', value: '25' },
  { label: '26th', value: '26' },
  { label: '27th', value: '27' },
  { label: '28th', value: '28' },
  { label: '29th', value: '29' },
  { label: '30th', value: '30' },
  { label: '31st', value: '31' },
];
const HOUR_OPTIONS = generateNumOptions(1, 13, 1);
const MINUTE_OPTIONS = generateNumOptions(0, 60, 5);
const AA_OPTIONS = [
  {
    label: 'AM',
    value: 'AM',
  },
  {
    label: 'PM',
    value: 'PM',
  },
];

class TimeSelector extends React.Component {
  constructor(props) {
    super(props);

    this._renderSelectField = this._renderSelectField.bind(this);
  }

  render() {
    const { interval, showMinutes, selectStyle, customStyles } = this.props;

    if (
      (interval === '15 Minutes' ||
        interval === '30 Minutes' ||
        interval === 'Hour' ||
        interval === 'N Hours') &&
      showMinutes
    ) {
      return (
        <div className="poll-time">
          <label>&nbsp;</label>
          {this._renderSelectField('mm', MINUTE_OPTIONS, 60, customStyles)}

          <label
            className="
              time-selector-label
              time-selector-label-outer
            "
          >
            &nbsp;minutes past the hour ({getLocalTimeZoneLabel()})&nbsp;
          </label>
        </div>
      );
    }

    const isWeek = interval === 'Week';
    const isMonth = interval === 'Month' || interval === 'N Months';

    return (
      <div className="poll-time">
        {this._renderSelectField('hh', HOUR_OPTIONS, 60, customStyles)}
        {showMinutes && (
          <label
            className="
              time-selector-label
              time-selector-label-outer
            "
          >
            &nbsp;:&nbsp;
          </label>
        )}
        {showMinutes && this._renderSelectField('mm', MINUTE_OPTIONS, 60, customStyles)}
        &nbsp;
        {this._renderSelectField('aa', AA_OPTIONS, 50, customStyles)}
        <label className="time-selector-label ">&nbsp;{getLocalTimeZoneLabel()}</label>
        {isWeek && (
          <label className="time-selector-label time-selector-label-inner ">&nbsp;on&nbsp;</label>
        )}
        {isWeek && this._renderSelectField('dayOfWeek', DAY_OF_WEEK_OPTIONS, 120, customStyles)}
        {isMonth && (
          <label className="time-selector-label time-selector-label-inner">
            &nbsp;on the&nbsp;
          </label>
        )}
        {isMonth && this._renderSelectField('dayOfMonth', DAY_OF_MONTH_OPTIONS, 60, customStyles)}
        {isMonth && (
          <label className="time-selector-label time-selector-label-inner">
            &nbsp;of the month
          </label>
        )}
      </div>
    );
  }

  _renderSelectField(name, options, width = 60, customStyles = false) {
    const selectionValue = getCurrentSelectedOption(options, this.props[name]);
    const styles = {
      ...baseSelectStyles,
      ...this.props.selectStyles,
      control: (base) => base,
      container: (base) => ({ ...base, minWidth: width }),
      menuPortal: (base) => ({ ...base, zIndex: 2000 }),
    };

    return (
      <Select
        menuPlacement="auto"
        value={selectionValue}
        options={options}
        components={{ Input: SelectInput, Option: SelectOption }}
        isClearable={false}
        backspaceRemovesValue={false}
        isSearchable={true}
        styles={customStyles || styles}
        onChange={(value) => this.props.onChange(name, value)}
      />
    );
  }
}

TimeSelector.defaultProps = {
  showMinutes: true,
};

export default TimeSelector;
